export default __webpack_public_path__ + "static/media/avatar3.bacd1e49.svg";